import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="lang-switcher">
      <button
        type="button"
        className={`lang-btn ${i18n.language?.startsWith('fr') ? 'active' : ''}`}
        onClick={() => changeLanguage('fr')}
        aria-label="Français"
      >
        FR
      </button>
      <button
        type="button"
        className={`lang-btn ${i18n.language?.startsWith('en') ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
